/**
 * Bootstrap module — importing it runs {@link initColor} as a side effect.
 *
 * This deliberate side-effect module exists because of ESM import hoisting:
 * all static imports of the entry point are fully evaluated before its module
 * body runs, so an explicit `initColor()` call in `index.tsx` would execute
 * *after* the command tree (and, transitively, chalk/ink) has loaded — too
 * late for the `FORCE_COLOR` override to influence chalk's color detection.
 * Importing this module before any chalk/ink-reachable import restores the
 * required ordering. Keep it free of other imports and side effects.
 */
import { initColor } from './color';

initColor();
